import { motion } from 'framer-motion'
import SEO from '../components/SEO'

export default function PrivacyClienti() {
  return (
    <div className="pt-24 pb-16">
      <SEO
        title="Privacy Clienti e Fornitori"
        description="Informativa privacy per clienti e fornitori di Bolletta Amica ai sensi del GDPR. Scopri come trattiamo i dati personali dei nostri partner."
        canonical="/privacy-clienti"
        noIndex={false}
      />
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-4xl mx-auto"
        >
          <h1 className="heading-lg mb-8">Informativa privacy clienti e fornitori</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-dark-700 font-semibold mb-4">
              Oggetto: Informativa per i clienti/fornitori sul Trattamento dei dati personali 
              (ai sensi del D.lgs. n. 196/2003 e dell'art. 13 GDPR Privacy n. 679/2016 e del D.lgs. 101/2018)
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-display font-bold mb-4">Premessa</h2>
              <p className="text-dark-600">
                Con la presente informativa Italconnect S.r.l., C.F./P.IVA 10663330966, con sede legale in 
                via Alessandro Volta, 24, 20099, Sesto San Giovanni (MI), in qualità di Titolare del Trattamento 
                dei dati, intende adempiere a quanto prescritto nel "Codice in materia di protezione dei dati 
                personali" D.lgs. 196/2003 – come modificato dal D.lgs. 101/2018 – e nel Regolamento Europeo n. 679/2016.
              </p>
              <p className="text-dark-600 mt-4">
                Per dato personale, per Trattamento e per tutte le altre nomenclature indicate nella presente 
                informativa si dovrà fare riferimento alle definizioni di cui all'art.4 del Regolamento.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-display font-bold mb-4">Oggetto</h2>
              <p className="text-dark-600">
                Italconnect S.r.l., in qualità di Titolare del Trattamento dei dati personali, informa il 
                cliente/fornitore in relazione all'instaurazione ed all'esecuzione del contratto in essere, 
                che Italconnect S.r.l. è tenuta a trattare dati personali che La riguardano.
              </p>
              <p className="text-dark-600 mt-4">
                I dati che verranno raccolti sono i suoi dati personali anagrafici e fiscali.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-display font-bold mb-4">2. Finalità del Trattamento dei dati</h2>
              <p className="text-dark-600 mb-4">
                I dati degli interessati, nel caso di specie dati personali, sono raccolti per le seguenti finalità:
              </p>
              <ul className="list-disc pl-6 text-dark-600 space-y-2">
                <li>Esecuzione del contratto;</li>
                <li>Riscontrare specifiche richieste, anche telefoniche, rivolte al Titolare del Trattamento;</li>
                <li>Adempimento di obblighi previsti da leggi connessi al rapporto contrattuale;</li>
                <li>Gestione del contratto, ad esempio rapporti con agenti, rappresentanti, committenti e/o appaltatori;</li>
                <li>Esercitare diritti del Titolare.</li>
                <li>Eventuali collaborazioni professionali esterne per l'adempimento degli obblighi di legge;</li>
                <li>Attività di marketing attraverso l'invio di materiale promozionale e pubblicitario inerente prodotti o servizi analoghi a quelli oggetto del rapporto commerciale in essere;</li>
              </ul>
              <p className="text-dark-600 mt-4">
                Specifiche misure di sicurezza sono osservate per prevenire la perdita dei dati, usi illeciti o 
                non corretti ed accessi non autorizzati.
              </p>
              <p className="text-dark-600 mt-4">
                La base giuridica del trattamento è il contratto, nonché l'esplicito consenso.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-display font-bold mb-4">3. Modalità del Trattamento dei dati</h2>
              <p className="text-dark-600">
                Il Trattamento dei dati è realizzato con l'ausilio di strumenti elettronici o supporti cartacei, 
                nel rispetto delle misure di sicurezza e protezione dei dati richiamate dal D.lgs. n. 196/2003 – 
                come modificato dal D.lgs. 101/2018 – e del Regolamento Europeo n. 679/2016.
              </p>
              <p className="text-dark-600 mt-4">
                Il trattamento potrà anche essere effettuato da terzi che forniscono specifici servizi elaborativi, 
                amministrativi o strumentali necessari per il raggiungimento delle finalità di cui sopra. Tutte le 
                operazioni di trattamento dei dati sono attuate in modo da garantire l'integrità, la riservatezza 
                e la disponibilità dei dati personali.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-display font-bold mb-4">4. Conservazione dei dati</h2>
              <p className="text-dark-600">
                I dati personali trattati per le finalità di cui al punto 2 saranno conservati per il tempo 
                strettamente necessario a raggiungere quelle stesse finalità nonché, trattandosi di trattamenti 
                svolti per la fornitura di servizi, sino al periodo di tempo previsto e ammesso dalla normativa 
                italiana a tutela degli interessi e del diritto di difesa di Italconnect S.r.l. avuto riguardo 
                ai termini di prescrizione previsti dalla normativa applicabile.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-display font-bold mb-4">5. Ambito di comunicazione e diffusione dei dati</h2>
              <p className="text-dark-600 mb-4">
                I Suoi dati personali potranno essere condivisi, per le finalità di cui alla sezione 2 della 
                presente Privacy Policy, con:
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">5.1</h3>
              <p className="text-dark-600">
                Soggetti che agiscono tipicamente in qualità di Responsabili del Trattamento, ossia: i) persone, 
                società o studi professionali che prestano attività di assistenza e consulenza a Italconnect S.r.l. 
                in materia contabile, amministrativa, legale, tributaria e finanziaria o altra consulenza aziendale; 
                ii) soggetti delegati a svolgere attività di manutenzione tecnica; iii) banche ed istituti di credito; 
                (collettivamente "Destinatari").
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">5.2</h3>
              <p className="text-dark-600">
                Soggetti, enti od autorità a cui sia obbligatorio comunicare i Suoi dati personali in forza di 
                disposizioni di legge o di ordini delle autorità;
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">5.3</h3>
              <p className="text-dark-600">
                Persone autorizzate da Italconnect S.r.l. al Trattamento di dati personali necessario a svolgere 
                attività strettamente correlate all'erogazione dei servizi, che si siano impegnate alla riservatezza 
                o abbiano un adeguato obbligo legale di riservatezza e che garantiscano il Trattamento dei Dati in 
                conformità del GDPR.
              </p>

              <p className="text-dark-600 mt-6">
                L'elenco completo ed aggiornato dei Responsabili è custodito presso la sede operativa del Titolare, 
                sita in Catanzaro e può essere trasmesso inviando una richiesta scritta al Titolare ai recapiti 
                indicati nella sezione "Contatti" di questa informativa.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-display font-bold mb-4">6. Base legale e natura obbligatoria o facoltativa del Trattamento</h2>
              
              <p className="text-dark-600 mb-4">
                La base legale del trattamento di dati personali per le finalità di cui alla sezione 2.2 e 2.3 e 2.4. 
                è l'art. 6(1)(b) del GDPR ([…]il trattamento è necessario all'esecuzione di un contratto di cui 
                l'interessato è parte o all'esecuzione di misure precontrattuali adottate su richiesta dello stesso […]), 
                in quanto i trattamenti sono necessari all'erogazione dei servizi e delle prestazioni. Il conferimento 
                dei dati personali per queste finalità è obbligatorio poiché l'eventuale mancato conferimento 
                comporterebbe l'impossibilità di fruire dei servizi erogati da Italconnect S.r.l.
              </p>

              <p className="text-dark-600 mb-4">
                La base legale per la finalità di cui alla sezione 2.1 è l'art. 6(1)(c) del GDPR ([…]il trattamento 
                è necessario per adempiere un obbligo legale al quale è soggetto il titolare del trattamento […]). 
                Una volta conferiti i dati personali, infatti, il trattamento è invero necessario per adempiere ad 
                obblighi di legge a cui Italconnect S.r.l. è soggetta.
              </p>

              <p className="text-dark-600 mb-4">
                La base legale per la finalità di cui alla sezione 2.5 è l'art. 6(1)(f) del GDPR ([…] il trattamento 
                è necessario per il perseguimento del legittimo interesse del titolare o di terzi, a condizione che 
                non prevalgano gli interessi o i diritti o le libertà fondamentali dell'Interessato […]) al fine di 
                accertare, esercitare o difendere un diritto in sede giudiziaria.
              </p>

              <p className="text-dark-600">
                La base legale per la finalità di cui alla sezione 2.6 è l'art. 6(1)(f) del GDPR ([…] il trattamento 
                è necessario per il perseguimento del legittimo interesse del titolare o di terzi, a condizione che 
                non prevalgano gli interessi o i diritti o le libertà fondamentali dell'Interessato […]) al fine di 
                promuovere ai propri clienti i servizi della Italconnect S.r.l.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-display font-bold mb-4">7. Diritti dell'interessato</h2>
              <p className="text-dark-600 mb-4">
                La informiamo che in qualità di interessato ha oltre il diritto di proporre reclamo a all'Autorità 
                di controllo, i diritti qui sotto elencati, che potrà far valere rivolgendo apposita richiesta al 
                Titolare del trattamento e/o al responsabile del trattamento, come indicati al punto 1.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">Art. 15 - Diritto di accesso</h3>
              <p className="text-dark-600">
                L'interessato ha il diritto di ottenere dal titolare del trattamento la conferma che sia o meno in 
                corso un trattamento di dati personali che lo riguardano e in tal caso, di ottenere l'accesso ai 
                dati personali e alle informazioni riguardanti il trattamento.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">Art. 16 – Diritto di rettifica</h3>
              <p className="text-dark-600">
                L'interessato ha il diritto di ottenere dal titolare del trattamento la rettifica dei dati personali 
                inesatti che lo riguardano senza ingiustificato ritardo. Tenuto conto delle finalità del trattamento, 
                l'interessato ha il diritto di ottenere l'integrazione dei dati personali incompleti, anche fornendo 
                una dichiarazione integrativa.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">Art. 17 – Diritto alla cancellazione (diritto all'oblio)</h3>
              <p className="text-dark-600">
                L'interessato ha il diritto di ottenere dal titolare del trattamento la cancellazione dei dati 
                personali che lo riguardano senza ingiustificato ritardo e il titolare del trattamento ha l'obbligo 
                di cancellare senza ingiustificato ritardo i dati personali.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">Art. 18 – Diritto di limitazione del trattamento</h3>
              <p className="text-dark-600 mb-2">
                L'interessato ha il diritto di ottenere dal titolare del trattamento la limitazione del trattamento 
                quando ricorre una delle seguenti ipotesi:
              </p>
              <ul className="list-disc pl-6 text-dark-600 space-y-2">
                <li>l'interessato contesta l'esattezza dei dati personali, per il periodo necessario al titolare del trattamento per verificare l'esattezza di tali dati personali;</li>
                <li>il trattamento è illecito e l'interessato si oppone alla cancellazione dei dati personali e chiede invece che ne sia limitato l'utilizzo;</li>
                <li>benché il titolare del trattamento non ne abbia più bisogno ai fini del trattamento, i dati personali sono necessari all'interessato per l'accertamento, l'esercizio o la difesa di un diritto in sede giudiziaria;</li>
                <li>l'interessato si è opposto al trattamento ai sensi dell'articolo 21, paragrafo 1, in attesa della verifica in merito all'eventuale prevalenza dei motivi legittimi del titolare del trattamento rispetto a quelli dell'interessato.</li>
              </ul>

              <h3 className="text-xl font-semibold mt-6 mb-3">Art. 20 – Diritto alla portabilità dei dati</h3>
              <p className="text-dark-600">
                L'interessato ha il diritto di ricevere in un formato strutturato, di uso comune e leggibile da 
                dispositivo automatico i dati personali che lo riguardano forniti a un titolare del trattamento e 
                ha il diritto di trasmettere tali dati a un altro titolare del trattamento senza impedimenti da 
                parte del titolare del trattamento cui li ha forniti.
              </p>
              <p className="text-dark-600 mt-4">
                Nell'esercitare i propri diritti relativamente alla portabilità dei dati a norma del paragrafo 1, 
                l'interessato ha il diritto di ottenere la trasmissione diretta dei dati personali da un titolare 
                del trattamento all'altro, se tecnicamente fattibile.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">Art. 21 – Diritto di opposizione</h3>
              <p className="text-dark-600">
                L'interessato ha il diritto di opporsi in qualsiasi momento, per motivi connessi alla sua situazione 
                particolare, al trattamento dei dati personali che lo riguardano ai sensi dell'articolo 6, paragrafo 1, 
                lettere e) o f), compresa la profilazione sulla base di tali disposizioni.
              </p>

              <h3 className="text-xl font-semibold mt-6 mb-3">Art. 22 – Diritto di non essere sottoposto a processo decisionale automatizzato, compresa la profilazione</h3>
              <p className="text-dark-600">
                L'interessato ha il diritto di non essere sottoposto a una decisione basata unicamente sul trattamento 
                automatizzato, compresa la profilazione, che produca effetti giuridici che lo riguardano o che incida 
                in modo analogo significativamente sulla sua persona.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-display font-bold mb-4">8. Titolare del Trattamento e contatti</h2>
              <p className="text-dark-600">
                Titolare del Trattamento dei dati personali è Italconnect S.r.l., con sede legale in Via Alessandro 
                Volta, 24, 20099, Sesto San Giovanni (MI), email:{' '}
                <a href="mailto:amministrazione@italconnectsrl.it" className="text-primary hover:underline">
                  amministrazione@italconnectsrl.it
                </a>
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  )
}
